import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

export default class CommentCountIndicator extends Component {
  constructor() {
    super()
    this.state = {
      id: Math.random()
    }
  }

  render() {
    const { commentCount } = this.props
    return (
      <div
        className="comment-count"
        data-for={`commentCountTooltip-${this.state.id}`}
        data-tip={commentCount > 1 ? 'Posted Comments' : 'Posted Comment'}
      >
        <ReactTooltip
          id={`commentCountTooltip-${this.state.id}`}
          effect="solid"
          offset={{ top: -2 }}
        />
        {this.props.commentCount}
      </div>
    )
  }
}

CommentCountIndicator.propTypes = {
  commentCount: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/comments/CommentCountIndicator.js